import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { func, shape, string } from 'prop-types';
import { mergeClasses } from '@magento/venia-ui/lib/classify';
import Button from '@magento/venia-ui/lib/components/Button';
import defaultClasses from './errorView.css';
import backgroundUrl from './errorViewBackground-1400x600.png';
import mobileBackgroundUrl from './errorViewBackground-380x600.png';
var DEFAULT_HEADER = 'Oups!';
var DEFAULT_MESSAGE = 'Looks like something went wrong. Sorry about that.';
var DEFAULT_PROMPT = 'Take me home';
var ErrorView = props => {
  var classes = mergeClasses(defaultClasses, props.classes);
  var history = useHistory();
  var handleGoHome = useCallback(() => {
    history.push('/');
  }, [history]);
  var {
    header = /*#__PURE__*/React.createElement(FormattedMessage, {
      id: 'errorView.header',
      defaultMessage: DEFAULT_HEADER
    }),
    message = /*#__PURE__*/React.createElement(FormattedMessage, {
      id: 'errorView.message',
      defaultMessage: DEFAULT_MESSAGE
    }),
    buttonPrompt = /*#__PURE__*/React.createElement(FormattedMessage, {
      id: 'errorView.goHome',
      defaultMessage: DEFAULT_PROMPT
    }),
    onClick = handleGoHome
  } = props;
  var handleClick = useCallback(() => {
    onClick && onClick();
  }, [onClick]);
  var style = {
    '--backroundImageUrl': "url(\"".concat(backgroundUrl, "\")"),
    '--mobileBackgroundImageUrl': "url(\"".concat(mobileBackgroundUrl, "\")")
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root,
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement("p", {
    className: classes.header
  }, header), /*#__PURE__*/React.createElement("p", {
    className: classes.message
  }, message), /*#__PURE__*/React.createElement("div", {
    className: classes.actionsContainer
  }, /*#__PURE__*/React.createElement(Button, {
    priority: "high",
    type: "button",
    onClick: handleClick
  }, buttonPrompt))));
};
ErrorView.propTypes = {
  header: string,
  message: string,
  buttonPrompt: string,
  onClick: func,
  classes: shape({
    root: string,
    content: string,
    errorCode: string,
    header: string,
    message: string,
    actionsContainer: string
  })
};
export default ErrorView;